import {
    faDotCircle,
    faLocationArrow,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import FlexContainer from "../FlexContainer/FlexContainer";

export default function MapDirections() {
    const [routeFromText, setRouteFromText] = useState("");
    const [routeToText, setRouteToText] = useState("");
    return (
        <>
            <div className="directions-menu-container">
                <FlexContainer alignItems="center">
                    <FontAwesomeIcon
                        icon={faDotCircle}
                        className="directions-menu-icon"
                    />
                    <input
                        placeholder="Ferðast frá..."
                        value={routeFromText}
                        onChange={(e) => {
                            setRouteFromText(e.target.value);
                        }}
                    />
                </FlexContainer>
                <div className="directions-separator"></div>
                <FlexContainer alignItems="center">
                    <FontAwesomeIcon
                        icon={faLocationArrow}
                        className="directions-menu-icon"
                    />
                    <input
                        placeholder="Ferðast til..."
                        value={routeToText}
                        onChange={(e) => {
                            setRouteToText(e.target.value);
                        }}
                    />
                </FlexContainer>
            </div>
            <button
                className="directions-menu-navigate-button"
                onClick={() => {}}
            >
                Leiðarvísun
            </button>
        </>
    );
}
